import React from 'react';
import { Button, Input, Modal, Typography } from 'antd';
import { IoPricetagsOutline } from "react-icons/io5";

const { Title, Text } = Typography;

const ListasPrecios = ({
    setOpenPrecios, isSavingPrecios, guardarPreciosAdicionales, listasPrecios, targetPrecios,
    producto, tempPrecios, setTempPrecios, calcularPrecioDesdeMargen, openPrecios, calcularMargenDesdePrecio
}) => {
    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px' }}>
                    <IoPricetagsOutline style={{ color: '#0f766e' }} />
                    <span>Configurar Listas de Precios</span>
                </div>
            }
            open={openPrecios}
            onCancel={() => setOpenPrecios(false)}
            centered
            zIndex={1005}
            width={450}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button
                        onClick={() => setOpenPrecios(false)}
                        style={{ height: '42px', borderRadius: '8px', padding: '0 20px' }}
                        disabled={isSavingPrecios}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="primary"
                        onClick={guardarPreciosAdicionales}
                        loading={isSavingPrecios}
                        style={{ height: '42px', borderRadius: '8px', padding: '0 25px', fontWeight: 'bold', background: '#22BABB', borderColor: '#22BABB' }}
                    >
                        Guardar Precios
                    </Button>
                </div>
            }
        >
            <div style={{ padding: '10px 0' }}>
                <Text type="secondary" style={{ marginBottom: '20px', display: 'block' }}>
                    Define los valores para las listas activas. El margen se ajusta automáticamente.
                </Text>

                {listasPrecios.map(lista => {
                    const costo = Number(targetPrecios === 'simple'
                        ? producto.precioCompra
                        : (producto.variantes[targetPrecios]?.precio_compra || 0)) || 0;

                    const precioActual = Number(tempPrecios[lista.id] || 0);
                    const margen = calcularMargenDesdePrecio(costo, precioActual);

                    return (
                        <div key={lista.id} style={{
                            background: '#f8fafc',
                            padding: '15px',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            marginBottom: '12px'
                        }}>
                            <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#1e293b', marginBottom: '8px', display: 'block' }}>
                                {lista.nombre}
                            </label>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Input
                                    prefix="$"
                                    placeholder="0"
                                    style={{ flex: 2, height: '42px', fontSize: '15px', fontWeight: 'bold' }}
                                    value={precioActual > 0 ? new Intl.NumberFormat('es-CO').format(precioActual) : ""}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
                                        const val = raw === "" ? 0 : Number(raw);
                                        setTempPrecios(prev => ({ ...prev, [lista.id]: val }));
                                    }}
                                />
                                <Input
                                    suffix="%"
                                    placeholder="Margen"
                                    style={{ flex: 1, height: '42px', fontSize: '15px', textAlign: 'center' }}
                                    value={margen}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/[^0-9.]/g, '');
                                        const nuevoPrecio = calcularPrecioDesdeMargen(costo, val);
                                        setTempPrecios(prev => ({ ...prev, [lista.id]: nuevoPrecio === "" ? 0 : Number(nuevoPrecio) }));
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    )
}

export default ListasPrecios;